import { api, badge, stickyMessage } from './util';
import { medicalDeviceGroupHelper } from './medical-device-group';
import { disLineChart, disStackedChart } from './product-open-data';
import { getUnitUtil } from './get-unit-util';

(function ($) {
	/**
	 * Download dis chart
	 * https://stackoverflow.com/a/28819615/430100
	 */

	$('#medical-device-distribution-show-distribution-poukaz').click(function () {
		$('#medical-device-distribution-search-form input[name=payment-type]').val('poukaz');
		$('#medical-device-distribution-search-form input[name=usage]').val('maximalReimbursementPoukaz');
		$('#medical-device-distribution-search-form').submit();
	});

	$('#medical-device-distribution-show-distribution-zum').click(function () {
		$('#medical-device-distribution-search-form input[name=payment-type]').val('zum');
		$('#medical-device-distribution-search-form input[name=usage]').val('maximalReimbursementZum');
		$('#medical-device-distribution-search-form').submit();
	});

	/**
	 * https://www.youtube.com/watch?v=PvP2ehmq2wo
	 */
	$('#medical-device-distribution-show-search').click(function () {
		let loc = window.location.href;
		window.location = loc.replace('medical-device/search/distribution', 'medical-device/search');
	});

	let medicalDeviceFormValidation = function () {
		if ($('#dis-content input[name=usage]:checked').val() === 'custom') {
			// Missing Group By check
			let noGroupBy = true;

			$('#dis-content select[name=group-by]').each(function () {
				if ($(this).val() !== '') {
					noGroupBy = false;
				}
			});

			if (noGroupBy) {
				// eslint-disable-next-line no-alert
				alert('Prosím vyberte alespoň jedno seskupení.');
				return false;
			}
		}

		if ($('#dis-content input[name=view-type]:checked').val() === undefined) {
			// eslint-disable-next-line no-alert
			alert('Prosím zvolte, jakým způsobem chceme zobrazit data');
			return false;
		}

		if ($('#dis-content input[name=period]:checked').val() === undefined) {
			// eslint-disable-next-line no-alert
			alert('Prosím zvolte periodu');
			return false;
		}
	};

	$('#medical-device-distribution-search-form').submit(function () {
		if (medicalDeviceFormValidation() === false) {
			return false;
		}

		$('#medical-device-distribution-submit').prop('disabled', true);
	});

	/**
	 * Generating .xls
	 */
	$(document).on('click', '.medical-device-distribution-js-export', function () {
		let btn = $(this);
		let originalText = btn.text();
		let url = btn.attr('data-href');
		let data = $('#medical-device-distribution-search-form').serialize();

		if (btn.hasClass('generating') || medicalDeviceFormValidation() === false) {
			return;
		}

		btn.addClass('generating');
		btn.text('Generuji .xls');

		api
			.get(`${url}?${data}`)
			.done(function (response) {
				if (response.status.success === false) {
					stickyMessage.show('error', response.status.message);
					return;
				}

				if (response.export.downloadUrl) {
					window.location.href = response.export.downloadUrl;
				} else {
					stickyMessage.show(
						'success',
						`Export je příliš velký. Po zpracování vám pošleme odkaz pro stažení na email ${response.export.asyncNotification.email}`
					);
				}
			})
			.always(function () {
				btn.removeClass('generating');
				btn.text(originalText);
			});

		return false;
	});
})(jQuery);

/**
 * Features of medicalDevice group detail.
 */
var medicalDeviceGroupDistributionDetail = (function ($) {
	var root;

	var init = function () {
		root = $('.medical-device-dis-detail');

		if (root.length === 0) {
			return;
		}

		root.find('.btn-cancel').click(cancelChangeFilters);
		root.find('.btn-edit').click(openSearchForm);
		$(document).on('medicalDeviceGroup.created', saveMedicalDeviceGroupFilters);
	};

	var openSearchForm = function () {
		root.find('.medical-device-group-edit-close').hide();
		root.find('.medical-device-group-edit-open').show();
		cloneSearchFormContainer();
	};

	var cloneSearchFormContainer = function () {
		// Clone the search form, so it is possible to cancel all changes with cancel button.
		// There is a problem with copying state of selects, so 'selected' attributed needs to be set.
		var originalSearchFormContainer = root.find('.search-form-container');
		originalSearchFormContainer.find('select').each(setOptionsSelectedAttribute);

		var searchFormContainer = originalSearchFormContainer.clone(true);
		root.find('.medical-device-group-search-form').prepend(searchFormContainer);

		// Initialize the search form.
		searchFormContainer.show();
		searchFormContainer.searchForm();

		root.find('.btn-create-medical-device-group').createMedicalDeviceGroupModal('.create-medical-device-group-modal');
	};

	/**
	 * Save medicalDevice group filters when medicalDevice group has been created.
	 *
	 * @param {object} event Event data.
	 * @param {{
	 *     medicalDeviceGroup: {
	 *         id: string,
	 *         type: string,
	 *         name: string,
	 *         notification: {
	 *             settings: {
	 *                 frequency: string
	 *             }
	 *         },
	 *         medicalDevicesCount:int
	 *     }
	 * }} response Data returned from the server.
	 */
	var saveMedicalDeviceGroupFilters = function (event, response) {
		medicalDeviceGroupHelper.createSaveFiltersApiRequest(response.medicalDeviceGroup.id).done(function () {
			medicalDeviceGroupHelper.redirectToMedicalDeviceGroupDetail(event, response);
		});
	};

	var setOptionsSelectedAttribute = function () {
		$(this)
			.find('option')
			.each(function () {
				$(this).attr('selected', $(this).is(':selected'));
			});
	};

	var cancelChangeFilters = function () {
		// Remove the search form which has been cloned in the openSearchForm function and this way
		// effectively discard all changes in medicalDevice group filters which should not be saved.
		var containers = root.find('.medical-device-group-search-form .search-form-container');

		if (containers.length > 1) {
			containers.first().remove();
		}

		// Close the search form.
		closeSearchForm();
	};

	var closeSearchForm = function () {
		hideSearchFormContainer();
		root.find('.medical-device-group-edit-open').hide();
		root.find('.medical-device-group-edit-close').show();
	};

	var hideSearchFormContainer = function () {
		var searchFormContainer = root.find('.medical-device-group-edit-open .search-form-container');
		searchFormContainer.searchForm('destroy');
		searchFormContainer.hide();
		badge.hide(root.find('.buttons .badge'));
	};

	return {
		init: init,
	};
})(jQuery);

function medicalDeviceDistributionChart() {
	if (!window.distributionChartData) {
		return;
	}

	var dates = window.distributionChartData.chartFlatPoints.reduce(function (result, point) {
		result[point.date] = {};
		return result;
	}, {});

	var sortedDates = Object.keys(dates);
	sortedDates.sort(function (a, b) {
		return Number(new Date(a)) - Number(new Date(b));
	});

	var byDate = window.distributionChartData.chartFlatPoints.reduce(function (result, point) {
		if (!result[point.date]) {
			result[point.date] = {};
		}
		result[point.date][point.name] = point.value;
		return result;
	}, {});

	var byName = Object.keys(byDate).reduce(function (result, date) {
		var sum = Object.values(byDate[date]).reduce(function (sum, value) {
			return sum + Math.abs(value);
		}, 0);

		Object.keys(byDate[date]).forEach(function (name, i) {
			if (!result[name]) {
				result[name] = {
					name: name,
					values: Object.assign({}, dates),
				};
			}
			result[name].values[date] = {
				value: byDate[date][name],
				percentage: (100 / sum) * byDate[date][name],
			};
		});
		return result;
	}, {});

	var data = Object.values(byName);
	var lastDate = sortedDates[sortedDates.length - 1];
	data.sort(function (a, b) {
		return b.values[lastDate].value - a.values[lastDate].value;
	});

	var periodQuarter = /period=quarter/.test(window.location.search);
	var intlDateFormatter = Intl.DateTimeFormat('cs-CZ', {
		month: periodQuarter || /period=year/.test(window.location.search) ? undefined : 'long',
		year: 'numeric',
	});
	var dateFormatter = function (date) {
		return (periodQuarter ? `Q${Math.round((date.getMonth() + 1) / 4) + 1} ` : '') + intlDateFormatter.format(date);
	};

	const name = window.disName || '';
	const subtitle = window.disSubtitle || '';
	const exportFilename = 'zp-distribution';
	const yAxisName = getUnitUtil({ omitUnit: window.distributionChartType === 'ONE_HUNDRED_CHART' }) || '';

	switch (window.distributionChartType) {
		case 'STACKED_GRAPH':
			disStackedChart(sortedDates, data, false, dateFormatter, {
				name: name,
				subtitle: subtitle,
				exportFilename,
				// @ts-expect-error: automatically injected
				unit: typeof window.chartUnit !== 'undefined' ? window.chartUnit : '',
				yAxisName: window.yAxisName || yAxisName,
			});
			break;

		case 'LINE_CHART':
			disLineChart(sortedDates, data, dateFormatter, {
				name: name,
				subtitle: subtitle,
				exportFilename,
				// @ts-expect-error: automatically injected
				unit: typeof window.chartUnit !== 'undefined' ? window.chartUnit : '',
				yAxisName: window.yAxisName || yAxisName,
			});
			break;

		case 'ONE_HUNDRED_CHART':
			disStackedChart(sortedDates, data, true, dateFormatter, {
				name: name,
				subtitle: subtitle,
				exportFilename,
				// @ts-expect-error: automatically injected
				unit: typeof window.chartUnit !== 'undefined' ? window.chartUnit : '',
				yAxisName: window.yAxisName || yAxisName,
			});
			break;
	}
}

export { medicalDeviceGroupDistributionDetail, medicalDeviceDistributionChart };
